import React from "react";
import { Field, Form, Formik } from "formik";
import { Button, Col, Dropdown, Modal, Row, Alert } from "react-bootstrap";
import { KeyboardArrowDown, MoreHoriz, Search } from "@material-ui/icons";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PhoneNumber from "../Common/phoneNumber";
import DeletePrompt from "../Common/DeletePrompt";
import {
  getAdminUsersAction,
  removeUsersAction,
  addAdminUserAction,
  activateAdminUser,
  searchUserAction,
} from "../../actions/UserActions";
import noRecord from "./../../assets/img/no-record.png";
import * as Yup from "yup";
import InputMask from "react-input-mask";
import { removeDashFromMobile, toastMessage } from "./../Common/Common";
import * as constant from "./../../config/Constants";
import * as helper from "../../config/CommonMessages";
import _ from "lodash";
import APIUtil from "./../../config/APIUtil";
import UrlConstants from "./../../config/UrlConstants";

class AdminUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showDelete: "Admin Users",
      showLoader: true,
      searchParam: "",
      deletePrompt: false,
      admins: [],
      originalAdmins: [],
      filteredAdmins: [],
      message: undefined,
      isFailed: undefined,
      username: "",
      mobileDuplicate: false,
    };
    this.deleteUserById = this.deleteUserById.bind(this);
  }

  columns = [
    {
      name: "NAME",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      width: "25%",
    },
    {
      name: "Mobile No.",
      selector: "mobile",
      sortable: true,
    },
    {
      name: "",
      selector: "active",
      sortable: true,
      width: "115px",
      ignoreRowClick: true,
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "50px",
    },
  ];

  setUserModal() {
    this.setState({ show: !this.state.show, mobileDuplicate: false });
  }

  getAdminUsers() {
    this.props.getAdminUsersAction().then((res) => {
      this.setState({
        admins: this.props.adminUsers || [],
        originalAdmins: this.props.adminUsers || [],
        filteredAdmins: this.props.adminUsers || [],
      });
    });
  }
  componentWillMount() {
    this.getAdminUsers();
  }

  openDeletePrompt(id) {
    this.setState({
      deletePrompt: true,
      userId: id,
    });
  }

  createAdmin(data) {
    data.mobileNumber = removeDashFromMobile(data.mobileNumber);
    if (data.otherNumber !== undefined) {
      data.otherNumber = removeDashFromMobile(data.otherNumber);
    }
    data.showSuccessMessage = false;
    data.username = data.username.trim().toLowerCase();
    data.firstname = data.firstname.trim();
    data.lastname = data.lastname.trim();
    data.email = data.email.trim();

    this.props.addAdminUserAction(data).then((res) => {
      if (res.status === constant.OK) {
        toastMessage(constant.SUCCESS, helper.ADMIN_USER_ADDED);
        this.setState({ show: !this.state.show }, () => {
          this.getAdminUsers();
        });
      } else if (res.status == constant.BAD_REQUEST) {
        toastMessage(constant.ERROR, res.data);
        this.setUserModal();
      } else {
        toastMessage(constant.ERROR, helper.SOMETHING_WENT_WRONG);
      }
    });
  }

  deleteUserById(uId) {
    this.setState({ showLoader: true, deletePrompt: false });
    this.props.removeUsersAction(uId).then((res) => {
      if (this.props.status) {
        this.getAdminUsers();
      }
    });
  }

  getSearchResult = _.debounce((param) => {
    this.setState({ showLoader: true });
    this.props
      .searchUserAction("admin", param.trim())
      .then((response) => {
        this.setState({
          admins: response.data.data,
          showLoader: false,
        });
      })
      .catch((err) => {});
  }, 1000);
  search(param) {
    this.getSearchResult(param);
    this.setState({
      searchParam: param,
      isSearched: param.trim() == "" ? false : true,
    });
  }

  reActivateUser(userId) {
    this.props
      .activateAdminUser(userId)
      .then((response) => {
        this.getAdminUsers();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let rows = [];

    for (var i = 0, len = this.state.admins.length; i < len; i++) {
      let user = this.state.admins[i];

      let data = {
        id: user._id,
        name: (
          <Link to={"/UserProfile/" + user._id} className="p-0 text-capitalize">
            {user.firstname} {user.lastname}
          </Link>
        ),
        mobile: <PhoneNumber phoneNumber={user.mobileNumber} />,
        email: <div className="email-case">{user.email.address}</div>,
        active: (
          <Button
            variant="primary"
            className={"btn-blue btn-grid "}
            disabled={!user.isDeleted}
            onClick={() => this.reActivateUser(user._id)}
          >
            Activate
          </Button>
        ),
        action:
          !user.isDeleted && user.email.address != "admin@dot.dotwork" ? (
            <Dropdown alignRight className="dropdown-action">
              <Dropdown.Toggle
                variant="transparent"
                id="dropdown-folder1"
                className="p-0"
              >
                <MoreHoriz />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  className="color-dark-orange-3 font-14"
                  onClick={() => {
                    this.openDeletePrompt(user._id);
                  }}
                >
                  Remove
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : null,
      };

      rows.push(data);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">{this.state.showDelete}</h4>
          </Col>
          <Col xs="4" align="right">
            <div className="icon-wrapper ml-2">
              <input
                type="text"
                className="form-control form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.search(e.target.value);
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
          <Col className="col-auto pl-0">
            <Button
              onClick={() => this.setUserModal()}
              variant="primary"
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Create Admin User
            </Button>
          </Col>
        </Row>

        <div className="dt-content-area">
          <DataTable
            columns={this.columns}
            data={rows}
            sortIcon={<KeyboardArrowDown className="color-grey-1" />}
            noDataComponent={
              <div className="no-transaction no-record no-datatable">
                <div className="no-transaction-inner">
                  <img src={noRecord} alt="no record" />
                  <p>No Admin Users Found</p>
                </div>
              </div>
            }
            highlightOnHover={true}
            className="rdt-requests"
            onRowSelected={this.getSelectedRows}
          />

          {/* add admin user */}
          <Modal
            show={this.state.show}
            onHide={() => this.setUserModal()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med1"
            backdrop={false}
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Create Admin User
              </Modal.Title>
            </Modal.Header>

            <Formik
              validateOnBlur={true}
              initialValues={this.state.propertyDataInfo}
              enableReinitialize={true}
              validationSchema={Yup.object().shape({
                username: Yup.string()
                  .required(helper.ENTER_USER_NAME)
                  .matches(new RegExp("^[a-z][a-z0-9@._]*$"), {
                    message: helper.ENTER_VALID_USER_NAME,
                    excludeEmptyString: true,
                  })
                  .test(
                    "Unique username",
                    helper.USER_NAME_EXISTS, // <- key, message
                    (value) => {
                      return new Promise((resolve, reject) => {
                        APIUtil.getMethod(
                          UrlConstants.usernameCheckUrl + "?username=" + value,
                          false
                        )
                          .then((response) => {
                            if (response.status === constant.OK) {
                              if (response.data === "duplicate") {
                                // set error as username duplicate
                                resolve(false);
                              } else {
                                resolve(true);
                              }
                            }
                          })
                          .catch((error) => {
                            resolve(false);
                          });
                      });
                    }
                  ),
                firstname: Yup.string()
                  .required(helper.ENTER_FIRST_NAME)
                  .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                    message: helper.ENTER_VALID_FIRST_NAME,
                  }),
                lastname: Yup.string()
                  .required(helper.ENTER_LAST_NAME)
                  .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                    message: helper.ENTER_VALID_LAST_NAME,
                  }),
                email: Yup.string()
                  .trim()
                  .email(helper.ENTER_VALID_EMAIL)
                  .required(helper.ENTER_EMAIL)
                  .test(
                    "Unique email",
                    helper.EMAIL_EXISTS, // <- key, message
                    (value) => {
                      return new Promise((resolve, reject) => {
                        APIUtil.getMethod(
                          UrlConstants.addContact +
                            "/CheckEmailOrMobileUniqueatregistration?email=" +
                            value,
                          false
                        )
                          .then((response) => {
                            if (
                              response &&
                              response.data &&
                              response.data.error === "Unauthorized" &&
                              response.data.data.email === 1
                            ) {
                              resolve(false);
                            } else {
                              resolve(true);
                            }
                          })
                          .catch((error) => {
                            resolve(true);
                          });
                      });
                    }
                  ),
                // mobileNumber: Yup.string()
                //   .required(helper.ENTER_MOBILE_NUMBER)
                //   .matches(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"), {
                //     message: helper.ENTER_VALID_MOBILE,
                //     excludeEmptyString: true,
                //   }),
                mobileNumber: Yup.string()
                  .required(helper.ENTER_MOBILE_NUMBER)
                  .matches(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"), {
                    message: helper.ENTER_VALID_MOBILE,
                    excludeEmptyString: true,
                  })
                  .test(
                    "Unique mobileNumber",
                    helper.MOBILE_NUMBER_EXISTS, // <- key, message
                    (value) => {
                      return new Promise((resolve, reject) => {
                        if ((value || "").length === 12) {
                          let data = value.replace(/-/g, "");
                          APIUtil.getMethod(
                            UrlConstants.addContact +
                              "/CheckEmailOrMobileUniqueatregistration?mobile=" +
                              data,
                            false
                          )
                            .then((response) => {
                              if (
                                response &&
                                response.data &&
                                response.data.error === "Unauthorized" &&
                                response.data.data.mobile === 1
                              ) {
                                resolve(false);
                              } else {
                                resolve(true);
                              }
                            })
                            .catch((error) => {
                              resolve(true);
                            });
                        } else {
                          resolve(true);
                        }
                      });
                    }
                  ),
                otherNumber: Yup.string().matches(
                  new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"),
                  {
                    message: helper.ENTER_VALID_MOBILE,
                    excludeEmptyString: true,
                  }
                ),
              })}
              onSubmit={(values, { setSubmitting }) => {
                this.createAdmin(values);
              }}
            >
              {({ handleChange, errors, values, handleBlur }) => (
                <Form className="form-sm form-admin" autoComplete={false}>
                  <Modal.Body className="pb-0">
                    <Row>
                      <Col sm="6" xs="12">
                        <div className="form-group">
                          <label>
                            Username<span className="text-danger"> *</span>
                          </label>
                          <Field
                            value={values.username}
                            type="text"
                            className="form-control"
                            name="username"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {errors.username}
                          </div>{" "}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" xs="12">
                        <div className="form-group">
                          <label>
                            First Name<span className="text-danger"> *</span>
                          </label>
                          <Field
                            value={values.firstname}
                            type="text"
                            className="form-control field_ucfirst"
                            name="firstname"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {errors.firstname}
                          </div>{" "}
                        </div>
                      </Col>

                      <Col sm="6" xs="12">
                        <div className="form-group">
                          <label>
                            Last Name<span className="text-danger"> *</span>
                          </label>
                          <Field
                            value={values.lastname}
                            type="text"
                            className="form-control field_ucfirst"
                            name="lastname"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {errors.lastname}
                          </div>{" "}
                        </div>
                      </Col>

                      <Col sm="6" xs="12">
                        <div className="form-group">
                          <label>
                            Email ID<span className="text-danger"> *</span>
                          </label>
                          <Field
                            value={values.email}
                            type="email"
                            className="form-control"
                            name="email"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {errors.email}
                          </div>{" "}
                        </div>
                      </Col>
                      <Col sm="6" xs="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="mobileNumber">
                            Mobile Number<span className="text-danger"> *</span>
                          </label>
                          <InputMask
                            mask="999-999-9999"
                            maskChar=""
                            className="form-control"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            value={values.mobileNumber}
                            name="mobileNumber"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            {(inputProps) => <Field {...inputProps} />}
                          </InputMask>
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {errors.mobileNumber}
                          </div>
                          {this.state.mobileDuplicate ? (
                            <div style={{ fontSize: 13, color: "#dc3545" }}>
                              {helper.MOBILE_NUMBER_EXISTS}
                            </div>
                          ) : (
                            ""
                          )}{" "}
                        </div>
                      </Col>

                      <Col sm="6" xs="12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="otherNumber">
                            Other Number
                          </label>
                          <InputMask
                            mask="999-999-9999"
                            maskChar=""
                            className="form-control"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            value={values.otherNumber}
                            name="otherNumber"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            {(inputProps) => <Field {...inputProps} />}
                          </InputMask>
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {errors.otherNumber}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-140"
                      onClick={() => {
                        this.setState({ show: false });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-blue w-140"
                    >
                      Create
                    </Button>
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          </Modal>

          <DeletePrompt
            deletePrompt={this.state.deletePrompt}
            itemId={this.state.userId}
            cancel={() => {
              this.setState({ deletePrompt: false });
            }}
            deleteConfirm={this.deleteUserById}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminUsers: state.reducer.adminUsers,
    totalAdminUsers: state.reducer.totalAdminUsers,
    status: state.reducer.status,
  };
};

export default connect(
  mapStateToProps,
  {
    getAdminUsersAction,
    removeUsersAction,
    addAdminUserAction,
    activateAdminUser,
    searchUserAction,
  }
)(AdminUsers);
